<template>
    <div id="compatible-devices" class="flex flex-col items-center mb-12">
        <h2 class="text-2xl text-san-marino-700 font-bold mb-8"
            >eSIM Uyumlu Cihazlar</h2
        >

        <Stepper linear value="1" class="w-full xl:w-3/4">
            <StepList>
                <Step value="1">İşletim Sistemi</Step>
                <Step value="2">Marka</Step>
                <Step value="3">Model</Step>
            </StepList>
            <StepPanels>
                <StepPanel v-slot="{ activateCallback }" value="1">
                    <div class="grid grid-cols-2 gap-4">
                        <Button
                            v-for="item in operatingSoftwares"
                            @click="moveBrands(item.value, activateCallback)"
                            :label="item.label"
                            :icon="item.icon"
                            iconPos="top"
                            class="h-52 lg:h-96 text-3xl lg:text-6xl drop-shadow-2xl"
                            :pt="{
                                root: 'relative items-center inline-flex justify-center',
                                label: 'font-normal',
                                icon: 'text-6xl drop-shadow-2xl',
                            }" />
                    </div>
                </StepPanel>
                <StepPanel v-slot="{ activateCallback }" value="2">
                    <ScrollPanel class="h-80">
                        <div class="grid grid-cols-3 lg:grid-cols-4 gap-4 lg:pr-4">
                            <Button
                                v-for="item in brands"
                                @click="
                                    brand = item.value;
                                    activateCallback('3');
                                "
                                :label="item.label"
                                class="h-36 lg:h-24"
                                :pt="{
                                    root: 'relative items-center inline-flex justify-center',
                                    label: 'font-normal',
                                }" />
                        </div>
                    </ScrollPanel>
                    <div class="pt-6">
                        <Button
                            label="Geri"
                            severity="secondary"
                            icon="pi pi-arrow-left"
                            @click="returnOperatingSystems(activateCallback)" />
                    </div>
                </StepPanel>
                <StepPanel v-slot="{ activateCallback }" value="3">
                    <ScrollPanel class="h-80">
                        <div class="grid grid-cols-3 lg:grid-cols-4 gap-4 lg:pr-4">
                            <Button
                                v-for="model in models"
                                :label="model.label"
                                class="h-36 lg:h-24"
                                :pt="{
                                    root: 'relative items-center inline-flex justify-center',
                                    label: 'font-normal',
                                }" />
                        </div>
                    </ScrollPanel>
                    <div class="pt-6">
                        <Button
                            label="Geri"
                            severity="secondary"
                            icon="pi pi-arrow-left"
                            @click="returnBrands(activateCallback)" />
                    </div>
                </StepPanel>
            </StepPanels>
        </Stepper>
    </div>
</template>

<script setup>
import { ref } from "vue";

const client = useSanctumClient();

const { data, pending, error, refresh } = await useAsyncData(
    "compatible-devices",
    () => client("/compatible-devices")
);

const devices = ref(data.value.data);

const brand = ref(null);
const brands = ref(null);
const models = ref(null);
const operatingSoftware = ref(null);

const operatingSoftwares = ref([
    { icon: "pi pi-apple", label: "iOS", value: "ios" },
    { icon: "pi pi-android", label: "Android", value: "android" },
]);

watch(operatingSoftware, (newVal) => {
    if (newVal === null) return;

    const filteredDevices = devices.value.filter(
        (device) => device.os === newVal
    );

    filteredDevices.forEach((device) => {
        device.brand = device.brand.toLowerCase();
    });

    const uniqueBrands = [
        ...new Set(filteredDevices.map((device) => device.brand)),
    ];

    brands.value = uniqueBrands.map((brand) => ({
        label: brand.charAt(0).toUpperCase() + brand.slice(1),
        value: brand,
    }));
});

watch(brand, (newVal) => {
    if (newVal === null) return;

    const filteredDevices = devices.value.filter(
        (device) => device.brand === newVal
    );
    models.value = filteredDevices.map((device) => ({
        label: device.name.charAt(0).toUpperCase() + device.name.slice(1),
    }));
});

const moveBrands = (software, callback) => {
    operatingSoftware.value = software;

    if (software === "ios") {
        brand.value = "apple";
        callback("3");
        return;
    }

    callback("2");
};

const returnOperatingSystems = (callback) => {
    operatingSoftware.value = null;
    models.value = null;
    callback("1");
};

const returnBrands = (callback) => {
    brand.value = null;
    models.value = null;
    callback("2");
};
</script>
